import { render, staticRenderFns } from "./ColumnViewBtn.vue?vue&type=template&id=38e8feef"
import script from "./ColumnViewBtn.vue?vue&type=script&lang=js"
export * from "./ColumnViewBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports